import { c as _c } from "react/compiler-runtime";
import { Flag } from '@7f-ui/components/flag/flag';
import { Price } from '@7f-ui/components/price';
import { shopTestId } from '@utils/utils-shop-test-ids';
type AccommodationDiscountProps = {
  price: number;
  currency?: string;
  discountPercentage: number;
};
export function AccommodationDiscount(t0) {
  const $ = _c(10);
  const {
    price,
    currency,
    discountPercentage
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = shopTestId("AccommodationDiscount.price");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== currency || $[2] !== price) {
    t2 = <Price amount={price} currency={currency} strikethrough={true} className="font-base-copy" dataTestId={t1} />;
    $[1] = currency;
    $[2] = price;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = shopTestId("AccommodationDiscount.flag");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== discountPercentage) {
    t4 = <Flag variant="success" dataTestId={t3}>- {discountPercentage}%</Flag>;
    $[5] = discountPercentage;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className="flex items-center gap-2">{t2}{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}